import { Component, OnInit, TemplateRef } from '@angular/core';
// import { TreeModule } from 'primeng';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import {MessageService} from 'primeng/api'


@Component({
    selector: 'app-initiate-delegation',
    templateUrl: './initiate-delegation.component.html',
    styleUrls: ['./initiate-delegation.component.css'],
    providers: [MessageService],
    standalone: false
})
export class InitiateDelegationComponent implements OnInit {
  
  ingredient!: string;
  sucImg =  "assets/images/tick.gif";
// on keyup input close btn show
  searchTxt:string='';
  closebtn:boolean=true;
brand: any;
rangeDates: any;
  changeEvt(e){
    if(this.searchTxt !=null || this.searchTxt !=""){
      this.closebtn=false;
    }
  }
  clearInput(){
    this.searchTxt="";
    this.closebtn=true;
  }
// on keyup input close btn show End

// Class Active & Inactive Toggled
delegateToggled = false;
delegateHideDiv = false;
public toggleDelegate() {
  this.delegateToggled = !this.delegateToggled;
  this.delegateHideDiv = !this.delegateHideDiv;  
}

durationToggled = false;
durationHideDiv = false;
public toggleDuration() {
  this.durationToggled = !this.durationToggled;
  this.durationHideDiv = !this.durationHideDiv;   
}

remarksToggled = false;
remarksHideDiv = false;
public toggleRemarks() {
  this.remarksToggled = !this.remarksToggled;
  this.remarksHideDiv = !this.remarksHideDiv;   
}
// Class Active & Inactive Toggled End


//range Calendar
ranges: any = [{
  value: [new Date(new Date().setDate(new Date().getDate() + 30)), new Date()],
  label: '1 Month'
}, {
  value: [new Date(), new Date(new Date().setDate(new Date().getDate() + 91))],
  label: '3 Months'
}, {
  value: [new Date(), new Date(new Date().setDate(new Date().getDate() + 182))],
  label: '6 Months'
}, {
  value: [new Date(), new Date(new Date().setDate(new Date().getDate() + 365))],
  label: '1 Year'
}
];

// Show and Hide Div
billing:boolean= true;
selectbilling:boolean= false;
addSpocD() {
this.billing= false;
this.selectbilling=true;
}

addSpocD1() {
  this.billing= true;
  this.selectbilling=false;
  }

  // Show and Hide Div
addApps:boolean= false;
selectApp:boolean= true;
addSpoc() {
this.addApps= true;
this.selectApp=false;
}

addSpocB() {
  this.addApps= false;
  this.selectApp=true;
  }



addApps1:boolean= false;
selectApp1:boolean= true;
addSpoc1() {
this.addApps1= true;
this.selectApp1=false;
}

addSpocA() {
  this.addApps1= false;
  this.selectApp1=true;
  }
// Show and Hide Div End

//  Select all CheckBox
mast = false;
child1 = false
child2 = false
child3 = false
child4 = false
child5 = false
child6 = false
child7 = false
master() {
this.mast = this.mast;
//console.log(this.mast)
if (this.mast === true) {
  this.child1 = true
  this.child2 = true
  this.child3 = true
  this.child4 = true
  this.child5 = true
  this.child6 = true
  this.child7 = true
}
if (this.mast === false) {
  this.child1 = false
  this.child2 = false
  this.child3 = false
  this.child4 = false
  this.child5 = false
  this.child6 = false
  this.child7 = false
} 
}
child(){
if(this.child1 === true && this.child2 === true && this.child3 === true && this.child4 === true
  && this.child5 === true && this.child6 === true && this.child7 === true){
  this.mast = true;
}
else{
  this.mast = false;
} 
}

// Roles (without Sub-Roles)  Select all CheckBox
mastR = false;
role1 = false
role2 = false
role3 = false
masterR() {
this.mastR = this.mastR;
if (this.mastR === true) {
  this.role1 = true
  this.role2 = true
  this.role3 = true
}
if (this.mastR === false) {
  this.role1 = false
  this.role2 = false
  this.role3 = false
} 
}
childR(){
if(this.role1 === true && this.role2 === true && this.role3 === true){
  this.mastR = true;
}
else{
  this.mastR = false;
} 
}

// Roles (along with Sub-Roles) Select all CheckBox
mastR1 = false;
lob1 = false
lob2 = false
masterR1() {
this.mastR1 = this.mastR1;
if (this.mastR1 === true) {
  this.lob1 = true
  this.lob2 = true
}
if (this.mastR1 === false) {
  this.lob1 = false
  this.lob2 = false
} 
}
childR1(){
if(this.lob1 === true && this.lob2 === true){
  this.mastR1 = true;
}
else{
  this.mastR1 = false;
} 
}
// BU Head Select all CheckBox
mastR2 = false;
bu1 = false
masterR2() {
this.mastR2 = this.mastR2;
if (this.mastR2 === true) {
  this.bu1 = true
}
if (this.mastR2 === false) {
  this.bu1 = false
} 
}
childR2(){
if(this.bu1 === true){
  this.mastR2 = true;
}
else{
  this.mastR2 = false;
} 
}

// Expand and Collapse All
  index: number = null;
//lastIndex = -2;
  txtTgl: boolean = true;
  openAll() {
    this.index = (this.index === 1) ? 0 : this.index + 1;
  }
// Expand and Collapse All End


// Success Alert Start
  showSuccess() {
    this.messageService.add({severity:'success',});
    setTimeout(() => {
      this.router.navigate(['/advanceDeligation']);
    }, 100);
  }
// Success Alert End


/* MODAL */
  modalRef: BsModalRef;
// Alert 
  alertIcon =  "assets/images/alert-01.svg";
    alert(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template,
    Object.assign({}, { class: 'alertM' })
    );
  }

  constructor(private modalService: BsModalService, private messageService: MessageService, private router: Router) { }

  ngOnInit(): void {
  }

  brands: string[] = [
    'Pawan Gupta (401267)',
    'Pawan Chobe (4016567)',
    'Pawan Misra (40126567)',
    'Pawan  Singh (26540167)',
    'Deivasigamani Tamilselvam (51897560)',
    'Anupama Parameswaran (40387651)'
  ];
  filteredBrands: any[];
  filterBrands(event) {
    this.filteredBrands = [];
    for(let i = 0; i < this.brands.length; i++) {
        let brand = this.brands[i];
        if (brand.toLowerCase().indexOf(event.query.toLowerCase()) == 0) {
            this.filteredBrands.push(brand);
        }
      }
  }  


  config = {
    backdrop: true,
    ignoreBackdropClick: true
  };
  openModal(approvedModal: TemplateRef<void>) {
    this.modalRef = this.modalService.show(approvedModal, this.config);
      document.body.classList.add('modal-open2');
  }
  hideSuccessMsg(){
    document.body.classList.remove('modal-open2');
  }




}
